export function resolveEffectiveStockQty(
  stockQty: number | null,
  stockControlEnabled: boolean,
): number | null {
  if (stockControlEnabled || stockQty === 0) {
    return stockQty;
  }
  return null;
}

export function isStockQtyOutOfStock(
  stockQty: number | null,
  stockControlEnabled: boolean,
): boolean {
  const effectiveStockQty = resolveEffectiveStockQty(stockQty, stockControlEnabled);
  return effectiveStockQty !== null && effectiveStockQty <= 0;
}

export function isProductOutOfStock(
  product: { id: string; presentationItemIds?: string[] },
  outOfStockIds: Set<string>,
): boolean {
  const stockIds = product.presentationItemIds ?? [product.id];

  return stockIds.every(id => outOfStockIds.has(id));
}

export function getOutOfStockIds(
  records: { id: string; stockQty: number | null }[] | null | undefined,
): Set<string> {
  return new Set(
    (records ?? []).filter(record => isStockQtyOutOfStock(record.stockQty, true)).map(record => record.id),
  );
}
